import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { EsnJobOfferService } from './../../../../core/services/esn-job-offer-service/esn-job-offer.service';
import { Component, inject, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { serverError } from './../../../../core/models/messages';
import { SalarieService } from './../../../../core/services/salarie-service/salarie.service';
import { ToastrService } from 'ngx-toastr';
import { Country, State } from 'country-state-city';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { translations } from '../../../../core/models/call-offer';
import { MatChipEditedEvent, MatChipInputEvent } from '@angular/material/chips';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { SubscriptionService } from '@core/services/subscription.service';
import { NgxSpinnerService } from 'ngx-spinner';
const DOMPurify = require('dompurify')

export interface addSkill {
  name: string;
}
@Component({
  selector: 'app-add-offer',
  templateUrl: './add-offer.component.html',
  styleUrls: ['./add-offer.component.css'],
})
export class AddOfferComponent {
  @ViewChild('publier', { static: true }) publierModal!: TemplateRef<any>;

  formjoboffer!: FormGroup;
  skillsList: { name_FR: string }[] = [];
  skills: any = [];
  types: any = [];
  addTestChecked: boolean = false;
  addScaleAndTest: boolean = false;
  selectedTest: string = '';

  addTestWegestU: boolean = false;
  addTest: boolean = false;
  addScale: boolean = false;
  addComp: boolean = true;

  modalRef?: BsModalRef;
  jobId: any;
  mobilities: any[] = [];
  updateSkills: any[] = [];

  private unsubscribeAll: Subject<void> = new Subject();

  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  stateList: any = [];
  states: any = [];
  countries: any = [];
  announcer = inject(LiveAnnouncer);
  formData = new FormData();
  addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;

  contrat = [
    { id: '1', name: 'Alternance' },
    { id: '2', name: 'Autres type de contrat' },
    { id: '3', name: 'CDD' },
    { id: '4', name: 'CDI' },
    { id: '5', name: 'Freelance' },
    { id: '6', name: 'Portage salarial' },
    { id: '7', name: 'Stage' },
  ];
  poste = [
    { id: 1, name: 'A distance' },
    { id: 2, name: 'Hybride' },
    { id: 3, name: 'Sur site' },
  ];
  disponibilite = [
    { id: 1, name: 'Immédiate' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
    { id: 6, name: '5 mois' },
  ];

  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private jobofferservice: EsnJobOfferService,
    private router: Router,
    private salarieservice: SalarieService,
    private modalBsService: BsModalService,
    private localStorageService: LocalStorageService,
    private subscriptionService: SubscriptionService,
    private spinner: NgxSpinnerService,
  ) {}
  toolbarOptions = [
    ['bold', 'italic', 'underline'], // toggled buttons
    [{ header: 1 }, { header: 2 }], // custom button values
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ color: [] }, { background: [] }], // outdent/indent
    ['clean'], // remove formatting button
  ];
   showPlaceholder: boolean = true;
  ngOnInit() {
    // @ts-ignore
    this.getListSkills();
    this.countries = Country.getAllCountries();
    this.formjoboffer = this.formBuilder.group({
      name: ['', Validators.required],
      post_type: [null],
      city: [[]],
      country: [[], Validators.required],
      availability: [null],
      salary: [''],
      years_of_experience: ['', Validators.required],
      contract_type: [[]],
      tjm: [''],
      description: ['', Validators.required],
      profile_abroad: [''],
      passeport_talent: [''],
      skills: [[], Validators.required],
      otherSkills: [[]],
    });
    this.contrat = this.contrat.sort((a, b) => {
      return a.name === 'Autres type de contrat' ? 1 : b.name === 'Autres type de contrat' ? -1 : 0;
    });
  }
  getListSkills() {
    this.salarieservice.getSkillsJobs().subscribe({
      next: (res: any) => {
        this.skillsList = res.data;
        const hasRefreshed = sessionStorage.getItem('hasRefreshed');
       if (!hasRefreshed) {
      sessionStorage.setItem('hasRefreshed', 'true'); 
      window.location.reload(); 
   
    } else {
      this.showPlaceholder = true;
    }
      },
      error: () => {
        this.toastr.error(serverError);
      },
    });
  }

  selectCountry() {
    console.log('data of create form : ', this.formjoboffer.value.country);
    this.states = State.getStatesOfCountry(this.formjoboffer.value.country);
    console.log('data of states form : ', this.states);
  }
  showPasseportTalent: boolean = false;

  onCountryChangeSearch(mode: string): void {

    this.formjoboffer.get('city')?.enable();
    this.countries = this.formjoboffer.get('country')?.value;
    this.countries = this.countries.map(
      (item:any) => this.paysList.filter((it) => it.name === item)[0]
    );
    this.stateList.length = 0;
    this.mobilities = this.formjoboffer.get('city')?.value;

    this.countries.forEach((item:any) => {
      var after:any[]=State.getStatesOfCountry(item?.isoCode)
      if(after.length==0)
      after.push({name:"Tout le pays"})
      this.stateList.push(after);
    });
    this.stateList = this.stateList.flat();
    for (const iterator of this.stateList) {
      iterator.name = iterator.name.replace(' Governorate', '');
    }
    this.stateList = this.stateList.map((item: any) => item.name);
    if (this.mobilities != null && this.mobilities.length > 0) {
      let differentItemsArray1: any[] = [];
      differentItemsArray1 = this.mobilities.filter(
        (item) => !this.stateList.includes(item)
      );
      var differentItemsArray2:any[]=[];
      differentItemsArray2= this.mobilities.filter((item) => !differentItemsArray1.includes(item));
      this.formjoboffer.get('city')?.setValue(differentItemsArray2);
    }

    if (this.stateList.length == 0) {
      this.stateList = [];
      mode == 'add';
      if(this.countries.length==0) {
        this.formjoboffer.get('city')?.disable();
        this.formjoboffer.get('city')?.setValue(null);
        }

    }
    this.showPasseportTalent = this.countries.some(
      (country: any) => country.name ==='France'
    );
    console.log("this.showPasseportTalent",this.showPasseportTalent)
  }

  onMobilityChange(mode: string) {
    this.mobilities = this.formjoboffer.get('city')?.value;
    let paysLists: any[] = [];
    this.countries = this.formjoboffer.get('country')?.value;
    this.countries = this.countries.filter(async (item: any) => {
      paysLists.push(this.paysList.filter((it) => it.name === item)[0]);
    });
    let stateListAfter: any[] = [];
    paysLists.forEach((item) => {
      State.getStatesOfCountry(item.isoCode).forEach(item=> {
        stateListAfter.push(item.name);    ////  }
      })
    });
    console.log('stateList in change mobilities mobilities : ', this.mobilities);
    console.log('stateList in change mobilities stateListAfter  : ', stateListAfter);
    this.stateList = [...new Set(this.mobilities.concat(stateListAfter))];
    console.log('stateList in change mobilities : ', this.stateList);
    this.mobilities = this.formjoboffer.get('city')?.value;

    if (this.countries.length != 0) {
      if (this.mobilities.length === 0 && this.stateList.length === 0) {
        this.onCountryChange('add');
      }
    }
  }
  onCountryChange(mode: string): void {
    this.formjoboffer.get('city')?.enable();
    this.countries = this.formjoboffer.get('country')?.value;
    this.countries = this.countries.map(
      (item: any) => this.paysList.filter((it) => it.name === item)[0]
    );

    console.log('item of countries ', this.countries);
    this.stateList.length = 0;
    // if (event.length) {
    this.countries.forEach((item: any) => {
      this.stateList.push(State.getStatesOfCountry(item.isoCode));
    });
    this.stateList = this.stateList.flat();
    for (const iterator of this.stateList) {
      iterator.name = iterator.name.replace(' Governorate', '');
    }
    this.stateList = this.stateList.map((item: any) => item.name);
    console.log('stateList ', this.stateList);
    this.mobilities = this.formjoboffer.get('city')?.value;
    if (this.mobilities != null && this.mobilities.length > 0) {
      console.log('size of mobilities ', this.mobilities.length);
      let differentItemsArray1: any[] = [];
      differentItemsArray1 = this.mobilities.filter(
        (item) => !this.stateList.includes(item)
      );
      const differentItemsArray2 = this.mobilities.filter(
        (item) => !differentItemsArray1.includes(item)
      );
      this.formjoboffer.get('city')?.setValue(differentItemsArray2);
    }
    // }
    if (this.stateList.length == 0) {
      this.stateList = [];
      mode == 'add';
      this.formjoboffer.get('city')?.setValue(null);
    }
    this.showPasseportTalent = this.countries.some(
      (country: any) => country.name ==='France'
    );
    console.log("this.showPasseportTalent",this.showPasseportTalent)
  }
  findDuplicates(array1: any, array2: any) {
    let occurrences: any[] = [];
    let duplicates: any = [];
    for (let element of array1) {
      occurrences[element] = (occurrences[element] || 0) + 1;
    }
    for (let element of array2) {
      if (occurrences[element] && !duplicates.includes(element)) {
        duplicates.push(element);
      }
    }

    return duplicates;
  }
  translateCountryName(name: string): string {

    return translations[name] || name;
  }
  openModal(template: TemplateRef<any>) {
    console.log('Open Modal called');
    console.log('Template:', template);
    this.modalRef = this.modalBsService.show(template, { backdrop: 'static' });
    console.log('Job ID:', this.jobId);
    this.modalRef.onHidden?.subscribe(() => {
      this.onConfirm(this.jobId);
    });
  }
  addSkills: addSkill[] = [];

  edit(skill: addSkill, event: MatChipEditedEvent) {
    const value = event.value.trim();

    if (!value) {
      this.remove(skill);
      return;
    }

    const index = this.addSkills.indexOf(skill);
    if (index >= 0) {
      this.addSkills[index].name = value;
    }
  }
  isFormatCompetenceAdmin: boolean = false;

  // add(event: MatChipInputEvent): void {
  //   const value: any = (event.value || '').trim();
  //   if (this.isFormatCompetence(value)) {
  //     if (!this.addSkills?.some((item) => item.name === value)) {
  //       this.updateSkills.push(value);
  //       this.addSkills?.push({ name: value });
  //       this.isFormatCompetenceAdmin = false;
  //     }
  //   } else {
  //     this.isFormatCompetenceAdmin = true;
  //   }
  //   event.chipInput!.clear();
  // }
  add(event: MatChipInputEvent): void {
    const value: any = (event.value || '').trim();

    if (value && this.isFormatCompetence(value)) {
      if (!this.addSkills.some(skill => skill.name === value)) {
        this.addSkills.push({ name: value });
          this.updateSkillsText();
      }
    }
      event.chipInput!.clear();
  }

  isFormatCompetence(competence: string): boolean {
    // Vérifie que la compétence commence par une lettre ou un chiffre, ne contient que des lettres, des chiffres, des espaces, des points, des hashtags ou des plus, et n'est pas composée uniquement de chiffres
    const pattern = /^(?!^\d+$)[a-zA-Z0-9][a-zA-Z0-9#.\s]*\+*$/;
    return pattern.test(competence);
  }
  // remove(skill: addSkill): void {
  //   const index = this.addSkills.indexOf(skill);

  //   if (index >= 0) {
  //     this.addSkills.splice(index, 1);

  //     this.updateSkillsText();

  //     this.formData.delete('otherSkills[]');

  //     this.addSkills.forEach((skill) => {
  //       this.formData.append('otherSkills[]', skill.name);
  //     });

  //     if (this.addSkills.length === 0) {
  //       this.formData.append('otherSkills[]', '');
  //     }

  //     this.announcer.announce(`Removed ${skill.name}`);
  //   }
  // }
  remove(skill: addSkill): void {
    const index = this.addSkills.indexOf(skill);

    if (index >= 0) {
      this.addSkills.splice(index, 1);
        this.updateSkillsText();
    }
  }

  // updateSkillsText(): void {
  //   const skillsText = this.addSkills.map((skill) => skill.name);
  //   this.formjoboffer.get('otherSkills')?.setValue(skillsText);

  //   this.formData.delete('otherSkills[]');
  //   skillsText.forEach((text) => {
  //     this.formData.append('otherSkills[]', text);
  //   });

  //   if (skillsText.length === 0) {
  //     this.formData.append('otherSkills[]', '');
  //   }
  // }
  updateSkillsText(): void {
    const skillsText = this.addSkills.map(skill => skill.name);
    this.formjoboffer.patchValue({ otherSkills: skillsText });
  }

  onConfirm(jobId: any) {
    if(this.addTestChecked) {
      this.router.navigate(['/offres-emploi/add-test-wegestu'],
        {
          queryParams: { jobId: jobId },
          state: {  testType: 'NO_TEST' },
        });
    }
    else if (this.addTestChecked && this.addTestWegestU) {
      this.router.navigate(['/offres-emploi/add-test-wegestu'],
        {
          queryParams: { jobId: jobId },
          state: {  testType: 'NO_TEST' },
        });
      console.log('add test wegestu');
    } else if (this.addTestChecked && this.addTest) {      
      this.router.navigate(['/offres-emploi/add-test'],
        {
          queryParams: { jobId: jobId },
          state: {  testType: 'NO_TEST' },
        });
    } else if (this.addScaleAndTest) {
      this.router.navigate([
        '/offres-emploi/add-bareme',
        { jobId: jobId , state:0},
      ]);
      console.log('add bareme');
    }
    else if (this.addScale) {
      this.router.navigate([
        '/offres-emploi/add-bareme',
        { jobId: jobId},
      ]);
      console.log('add bareme');
    }
    this.closeModal()
  }
  closeModal() {
    this.modalRef?.hide();
  }
  closeModalAndRedirect() {
    // Réinitialiser les états des cases à cocher
    this.addScale = false;
    this.addTestChecked = false;
    this.addTest = false;
    this.addTestWegestU = false;

    // Fermer la modale et rediriger
    this.modalRef?.hide();
    this.router.navigate(['/offres-emploi/liste-offres-emploi']);
}
  createjoboffer() {

 
    if (this.formjoboffer.invalid) {
      
      return;
    }

    if (this.formjoboffer.value.profile_abroad == true) {
      this.formjoboffer.patchValue({ profile_abroad: 1 });
    } else { 
      this.formjoboffer.patchValue({ profile_abroad: 0 });
    }
    if (this.formjoboffer.value.passeport_talent == true) {
      this.formjoboffer.patchValue({ passeport_talent: 1 });
    } else {
      this.formjoboffer.patchValue({ passeport_talent: 0 });
    }
    this.formjoboffer.markAllAsTouched();
    this.formjoboffer.markAsDirty();
    let skills = this.formjoboffer.get('skills')?.value;
    let otherSkills = this.formjoboffer.get('otherSkills')?.value;

    if (!otherSkills || otherSkills.length === 0) {
      this.formjoboffer.patchValue({ otherSkills: null });
    }

    this.formjoboffer.patchValue({
      years_of_experience: String(this.formjoboffer.value.years_of_experience),
      salary: String(this.formjoboffer.value.salary),
      tjm: String(this.formjoboffer.value.tjm),
    });
    if (this.formjoboffer.value.availability === null) {
      delete this.formjoboffer.value.availability;
    }
    if (this.formjoboffer.value.post_type === null) {
      delete this.formjoboffer.value.post_type;
    }

    this.jobofferservice.createjoboffer(this.formjoboffer.value).subscribe({
      next: (response) => {
        if(skills.length == 0){
          this.addComp = true;
        }
        else{
          this.addComp = false;
        }
        this.toastr.success('Offre emploi a été ajoutée avec succès');
        this.jobId = response.data.uuid;
        // this.formjoboffer.reset();
      
        this.openModal(this.publierModal);
      },
      error: (error: any) => {
     
        if (error.status === 403 && error.error.message) {
          this.toastr.error(error.error.message);
        } else {
          this.toastr.error('Une erreur est survenue lors de l\'ajout de l\'offre');
        }
      },
    });
  }

  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
  onAddScaleChange() {
    if (this.addScale) {
        this.addTestChecked = false;
    }
}


onTestChange(): void {
  if (this.selectedTest === 'wegestu') {
    this.addTestWegestU = true;
    this.addTest = false;  // Ensure mutual exclusivity
  } else if (this.selectedTest === 'test') {
    this.addTestWegestU = false;
    this.addTest = true;  // Ensure mutual exclusivity
  }
}
onAddTestChange() {
    if (this.addTestChecked) {
        this.addScale = false;
        this.addScaleAndTest =false
    }
    else if(this.addScale){
      this.addTestChecked = false;
      this.addScaleAndTest =false
    }
    else if(this.addScaleAndTest){
      this.addScale = false;
      this.addTestChecked =false
    }
}
subscriptionCanAccess(featureName: string): boolean {
  return this.subscriptionService.subscriptionCanAccess(featureName);
}
onContentChange(event: any): void {
  if (event.html) {
    const sanitizedContent = DOMPurify.sanitize(event.html);
    if (sanitizedContent !== this.formjoboffer.get('description')?.value) {
      this.formjoboffer.patchValue(
        { description: sanitizedContent },
        { emitEvent: false } 
      );
    }
  }

}
}
